import'./download-screen.scss'

/**
 *  Component Definition
 *
 * @export
 * @class DownloadScreen
 * @implements {ng.IComponentOptions}
 */
export class DownloadScreen implements ng.IComponentOptions {

  /**
   * Controller used with Component
   *
   * @type {Function}
   */
  public controller: Function = DownloadScreenController

  /**
   * Template used with Component
   *
   * @type {string}
   */
  public template: string = require('./download-screen.html').toString()

  /**
   * Object containing pairs Directive Bindings for Component
   *
   * @type {Object}
   */
  public bindings: { [binding: string]: string; } = {
    options: '=',
    isLast: '@',
    isFirst: '@',
  }
}

/**
 * DownloadScreen - Controller
 *
 * @export
 * @class DownloadScreenController
 */
export class DownloadScreenController {

  /**
   * $inject to make angular DI minification safe
   *
   * @static
   * @type {Array<string>}
   */
  public static $inject: [string] = ['$log', 'AngularServices', 'AppServices', '$element', 'ProgressManager', 'TrackingManager', 'PixiManager', '$animate']
  public options
  public isLast
  public isFirst
  public container
  public image

  /**
   * @param {*} $log Angular Log Service
   * @param {*} AngularServices Angular Services Convenience Service
   * @param {*} AppServices App Services Convenience Service
   */
  constructor(public $log: any, public AngularServices: any, public AppServices: any, public $element: any, public ProgressManager: any, public TrackingManager: any, public PixiManager: any, public $animate: any) {
    this.$log = $log.getInstance('DownloadScreen', false);
    this.$log.debug('constructor')
  }

  public onNext() {
    this.AppServices.ScreenManager.performNavigation('next', this.options)
  }

  public onPrevious() {
    this.AppServices.ScreenManager.performNavigation('previous', this.options)
  }

  public onEnterStart() {
    this.$log.debug('onEnterStart');

  }

  public onEnterComplete() {
    this.$log.debug('onEnterComplete');
    this.image.src = this.AppServices.PixiManager.getCoverDataURI();
    this.$animate.removeClass(document.querySelector('.screen-container__loader'), 'visible')
    this.$animate.removeClass(document.querySelector('.screen-container__loader-overlay'), 'visible')
  }

  public onExitStart() {
    this.$log.debug("onExitStart")
    this.options.navReady = false
    let printImage = document.querySelector('.print-screen__cover')
    if (printImage){
      printImage.parentElement.removeChild(printImage)
    }
    var leftOverlay = document.querySelector('.left-overlay')
    if (leftOverlay){
      this.$animate.addClass(leftOverlay, 'hide')
    }
    var rightOverlay = document.querySelector('.right-overlay')
    if (rightOverlay){
      this.$animate.addClass(rightOverlay, 'hide')
    }
    var downloadButtonContainer = document.querySelector('.download-button-container')
    if (downloadButtonContainer){
      this.$animate.addClass(downloadButtonContainer, 'hide')
    }
    var printButton = document.querySelector('.print-button')
    if (printButton){
      this.$animate.addClass(printButton, 'hide')
    }
    // this.AngularServices.$animate.removeClass(angular.element(document.querySelector('.landing-screen__start')), 'flipInX');
    // this.AngularServices.$animate.addClass(angular.element(document.querySelector('.landing-screen__start')), 'flipOutX');
  }

  public onExitComplete() {
    this.$log.debug("onExitComplete")

  }

  /**
   * life cycle hooks (road to ng2)
   * Called on each controller after all the controllers on an element have been constructed and had their bindings initialized (and before the pre & post linking functions for the directives on this element).
   */
  public $onInit(): void {
    this.$log.debug('onInit')
    this.options.isLast = this.isLast;
    this.options.isFirst = this.isFirst;
    this.options.$element = this.$element;
    this.options.$ctrl = this;
    this.options.lastPage = true
    this.AppServices.ScreenManager.downloadScreenOptions = this.options

    this.container = document.querySelector(".download-screen__cover-container");
    this.image = new Image();
    this.image.className = "download-screen__cover";
    this.container.appendChild(this.image);
  }

  public shareThisImage(): void{
    this.$log.debug('shareThisImage')
    this.$animate.addClass(document.querySelector('.screen-container__loader'), 'visible')
    this.$animate.addClass(document.querySelector('.screen-container__loader-overlay'), 'visible')
    let image = this.PixiManager.generateCover()
    let gender = this.ProgressManager.getGender();
    let pose =this.ProgressManager.getPose();
    this.AngularServices.$http({
        method : 'POST',
        headers: {
            "Content-Type": "application/json; charset=UTF-8"
        },
        url : 'https://assets.marvelhq.com/share/share.php',
        //url : 'http://localhost/marvelShare/share.php',
        data: {'game': 'MarvelIronMan', 'image' : image , 'gender' : gender + '@2x' , 'pose' : pose}
    }).then((response) => {
        let file = response.data.split('/')
        this.AppServices.ScreenManager.openModal(file[file.length-1]);
        this.TrackingManager.trackShares()
        this.$animate.removeClass(document.querySelector('.screen-container__loader'), 'visible')
        this.$animate.removeClass(document.querySelector('.screen-container__loader-overlay'), 'visible')
    });
  }

  /**
   * Called whenever one-way bindings are updated.
   * The changesObj is a hash whose keys are the names of the bound properties that have changed, and the values are an object of the form { currentValue, previousValue, isFirstChange() }.
   * Use this hook to trigger updates within a component such as cloning the bound value to prevent accidental mutation of the outer value.
   */
  public $onChanges(changesObj): void {
    this.$log.debug('onChanges', changesObj)
  }

  /**
   * Called on a controller when its containing scope is destroyed.
   * Use this hook for releasing external resources, watches and event handlers.
   */
  public $onDestroy(): void {
    this.$log.debug('onDestroy')
  }

  /**
   * Called after this controller's element and its children have been linked.
   * Similar to the post-link function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   * Note that child elements that contain templateUrl directives will not have been compiled and linked since they are waiting for their template to load asynchronously and their own compilation and linking has been suspended until that occurs.
   * This hook can be considered analogous to the ngAfterViewInit and ngAfterContentInit hooks in Angular 2.
   * Since the compilation process is rather different in Angular 1 there is no direct mapping and care should be taken when upgrading.
   */
  public $postLink(): void {
    this.$log.debug('postLink')
  }

}



/** WEBPACK FOOTER **
 ** ./src/components/download-screen/download-screen.ts
 **/